export const plansTranslation = {
    en: {
      plans: "Plans",
      home: "Home",
      planName: "Plan Name",
      description: "Description",
      priceMonthly: "Price (Monthly)",
      priceYearly: "Price (Yearly)",
      status: "Status",
      action: "Action",
      editPlan: "Edit Plan",
      addNewPlan: "Add New Plan",
      updatePlan: "Update Plan",
      addPlan: "Add Plan",
      searchPlan: "Search Plan",
      addPlanButton: "+ Add Plan",
      edit: "Edit",
      delete: "Delete",
      areYouSureDelete: "Are you sure you want to delete",
      thisActionCannotBeUndone: "This action cannot be undone.",
      cancel: "Cancel",
      planDeletedSuccessfully: "Plan deleted successfully!",
      failedToDeletePlan: "Failed to delete plan.",
      'Add Feature Button': "Add Feature",
      'Update Feature': "Update Feature",
      'Edit Feature': "Edit Feature",
      'Add New Feature': "Add New Feature",
      'Delete Feature Confirmation': "Are you sure you want to delete this feature",
      "Number of years": "Number of years",
      "Number of Months": "Number of months",
      "Number of Days": "Number of days",
      "Enter Number of Years": "Enter Number of Years",
      "Enter Number of Months": "Enter Number of Months",
      "Enter Number of Days": "Enter Number of Days",
      "Price Daily": "Price Daily",
      "Plan Type": "Plan Type",
      "Enter Daily Price": "Enter Daily Price",
      "Is Free": "Is Free",
      priceDaily: "Price (Daily)",
      "Daily": "Daily",
    },
    ar: {
      plans: "الخطط",
      home: "الصفحة الرئيسية",
      planName: "اسم الخطة",
      description: "الوصف",
      priceMonthly: "السعر (شهريًا)",
      priceYearly: "السعر (سنويًا)",
      status: "الحالة",
      action: "الإجراء",
      editPlan: "تعديل الخطة",
      addNewPlan: "إضافة خطة جديدة",
      updatePlan: "تحديث الخطة",
      addPlan: "إضافة خطة",
      searchPlan: "بحث عن خطة",
      addPlanButton: "+ إضافة خطة",
      edit: "تعديل",
      delete: "حذف",
      areYouSureDelete: "هل أنت متأكد أنك تريد حذف",
      thisActionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",
      cancel: "إلغاء",
      planDeletedSuccessfully: "تم حذف الخطة بنجاح!",
      failedToDeletePlan: "فشل في حذف الخطة.",
      'Add Feature Button': "إضافة ميزة",
      'Update Feature': "تحديث الميزة",
      'Edit Feature': "تعديل الميزة",
      'Add New Feature': "إضافة ميزة جديدة",
      'Delete Feature Confirmation': "هل أنت متأكد أنك تريد حذف هذه الميزة",
      "Number of years": "عدد السنوات",
      "Number of Months": "عدد الأشهر",
      "Number of Days": "عدد الأيام",
      "Enter Number of Years": "أدخل عدد السنوات",
      "Enter Number of Months": "أدخل عدد الأشهر",
      "Enter Number of Days": "أدخل عدد الأيام",
      "Price Daily": "السعر اليومي",
      "Plan Type": "نوع الخطة",
      "Enter Daily Price": "أدخل السعر اليومي",
      "Is Free": "مجاني",
      priceDaily: "السعر (يوميًا)",
      "Daily": "يوميًا",
    },
  };
  